
document.querySelectorAll('[data-section-type="carousel"]').forEach(function(container) {
  const loader = new WAU.Helpers.scriptLoader();

  loader.load([jsAssets.flickity]).finally(function() {
    setTimeout(function() {
      carouselInit(container);
    }, 200);
  });
});

document.addEventListener('shopify:section:load', function(event) {
  if (!event.target.querySelector('[data-section-type="carousel"]')) {
    return;
  }

  setTimeout(function() {
    carouselInit(event.target);

    // If testimonials section.
    if (
      event.target.querySelector('[data-section-type]')?.matches(
        '.section-testimonials'
      )
    ) {
      carouselSlideLast(event.target);
    }
  }, 200);
});

document.addEventListener('shopify:block:select', function(event) {
  var container = event.target.closest('[data-section-type]');

  if (!container) return;

  if (container.getAttribute('data-section-type') === 'carousel') {
    setTimeout(function() {
      carouselSlideEdit(event.target);
    }, 200);
  }
});

document.addEventListener('shopify:block:deselect', function(event) {
  var container = event.target.closest('[data-section-type]');

  if (!container) return;

  if (container.getAttribute('data-section-type') === 'carousel') {
    if (container.classList.contains('section-image-carousel-text')) {
      carouselSlideReset(event.target);
    }

    // If testimonials section.
    if (
      event.target.closest('[data-section-type]')?.matches(
        '.section-testimonials'
      )
    ) {
      carouselSlideFirst(event.target);
    }

    carouselSlideRestart(event.target);
  }
});


function carouselSlideFirst(container) {
  let carousel = container.closest('.js-carousel');

  if (!carousel) return false;

  let flkty = Flickity.data(carousel);

  if (!flkty) return false;

  flkty.select(0);
}


function carouselSlideLast(container) {
  let carousel = container.querySelector('.js-carousel');

  if (!carousel) return false;

  let flkty = Flickity.data(carousel);

  if (!flkty) return false;

  flkty.select(flkty.cells.length - 1);
}


/*
 * Carousel initialization.
 *
 * Mobile product recommendations:
 * - Grid selected: destroy Flickity and enable CSS grid.
 * - Carousel selected: use the existing Flickity settings.
 * - Desktop: preserve the original carousel.
 */

function carouselInit(container) {
  var carousel = container.querySelector(
    '.js-carousel, .rec-mobile-grid-active'
  );

  if (!carousel) return false;

  var isMobile = window.matchMedia(
    '(max-width: 767px)'
  ).matches;

  var mobileDisplay = carousel.getAttribute(
    'data-mobile-display'
  );

  // MOBILE GRID MODE: Do not initialize Flickity.
  if (isMobile && mobileDisplay === 'grid') {
    var existingFlickity =
      window.Flickity &&
      typeof window.Flickity.data === 'function'
        ? window.Flickity.data(carousel)
        : null;

    if (existingFlickity) {
      existingFlickity.destroy();
    }

    carousel.classList.remove('js-carousel');
    carousel.classList.add('rec-mobile-grid-active');

    var columns = carousel.getAttribute(
      'data-mobile-grid-columns'
    ) || '2';

    carousel.style.setProperty(
      '--mobile-grid-columns',
      columns === '1' ? '1' : '2'
    );

    carousel.classList.remove('is-hidden');

    return false;
  }

  // CAROUSEL MODE: restore the original carousel class.
  if (carousel.classList.contains('rec-mobile-grid-active')) {
    carousel.classList.remove('rec-mobile-grid-active');

    carousel.style.removeProperty('--mobile-grid-columns');

    carousel.classList.add('js-carousel');
  }

  // Avoid initializing Flickity twice.
  if (
    window.Flickity &&
    typeof window.Flickity.data === 'function' &&
    window.Flickity.data(carousel)
  ) {
    window.Flickity.data(carousel).resize();
    return true;
  }

  if (carousel.classList.contains('carousel-loaded--false')) {
    carousel.classList.remove('carousel-loaded--false');
    carousel.classList.add('carousel-loaded--true');
  }

  var flktyOptions;

  // Carousel on mobile only.
  if (
    container.querySelector('[data-flickity-mobile]') &&
    WAU.Helpers.isMobile()
  ) {
    const flktyData = carousel.getAttribute(
      'data-flickity-mobile'
    );

    flktyOptions = JSON.parse(flktyData);

  } else if (container.querySelector('[data-flickity-other]')) {

    const flktyData = carousel.getAttribute(
      'data-flickity-other'
    );

    flktyOptions = JSON.parse(flktyData);

  } else {

    const flktyData = carousel.getAttribute('data-flickity');

    if (!flktyData) return false;

    flktyOptions = JSON.parse(flktyData);
  }

  new Flickity(carousel, flktyOptions);

  carousel.classList.remove('is-hidden');

  carouselResize(carousel);
  carouselAccesibility(carousel);

  var flkty = Flickity.data(carousel);

  if (!flkty) return false;

  flkty.offsetHeight;

  // Bail if a testimonials container.
  if (
    !carousel.classList.contains(
      'section-testimonials__inner-wrapper'
    )
  ) {
    // Carousel pagination.
    var carouselPag = container.querySelector(
      '.js-carousel-pagination'
    );

    if (carouselPag) {
      carouselPagination(carousel, carouselPag);
    }
  }

  // Carousel drag fix on mobile.
  flkty.on('dragStart', function() {
    document.ontouchmove = function(e) {
      e.preventDefault();
    };
  });

  flkty.on('dragEnd', function() {
    document.ontouchmove = function() {
      return true;
    };
  });

  return true;
}


function carouselAccesibility(carousel) {
  var flkty = Flickity.data(carousel);

  if (!flkty) return;

  if (flkty.nextButton) {
    flkty.handles[0].before(flkty.nextButton.element);
    flkty.nextButton.element.before(flkty.prevButton.element);
  }
}


function carouselSlideEdit(container) {
  var carousel = container.closest('.js-carousel');

  if (!carousel) return false;

  var flkty = Flickity.data(carousel);

  if (!flkty) return false;

  var slide = container.getAttribute('data-slide-index');

  flkty.select(slide);
  flkty.pausePlayer();
}


function carouselSlideRestart(container) {
  var carousel = container.closest('.js-carousel');

  if (!carousel) return false;

  const flkty = Flickity.data(carousel);

  if (!flkty) return false;

  flkty.unpausePlayer();
}


function carouselSlideReset(container) {
  var carousel = container.closest('.js-carousel');

  if (!carousel) return false;

  const flkty = Flickity.data(carousel);

  if (!flkty) return false;

  flkty.select(0);
}


function carouselResize(carousel) {
  var flkty = Flickity.data(carousel);

  if (!flkty) return false;

  flkty.resize();
}


function carouselPagination(carousel, pagination) {
  var flkty = Flickity.data(carousel);

  if (!flkty) return false;

  document.addEventListener('click', function(event) {
    if (
      event.target.classList &&
      event.target.classList.contains('js-nav-item')
    ) {
      removeClasses();

      event.target.classList.add('is-nav-selected');

      flkty.select(event.target.dataset.slideIndex);
    }
  });

  flkty.on('change', function(index) {
    let item = pagination.querySelector(
      '[data-slide-index="' + index + '"].js-nav-item'
    );

    if (!item) return;

    removeClasses();

    item.classList.add('is-nav-selected');
  });

  function removeClasses() {
    pagination.querySelectorAll('.js-nav-item').forEach(function(item) {
      item.classList.remove('is-nav-selected');
    });
  }
}


/*
 * Switch product recommendations between mobile Grid and Carousel
 * when the viewport changes.
 */

(function() {
  var resizeTimer;

  function updateProductRecommendationLayouts() {
    var loops = document.querySelectorAll(
      '.product-recommendations__wrapper--loop[data-mobile-display]'
    );

    var isMobile = window.matchMedia(
      '(max-width: 767px)'
    ).matches;

    loops.forEach(function(loop) {
      var mode = loop.getAttribute('data-mobile-display');

      if (isMobile && mode === 'grid') {
        var flkty =
          window.Flickity &&
          typeof window.Flickity.data === 'function'
            ? window.Flickity.data(loop)
            : null;

        if (flkty) {
          flkty.destroy();
        }

        loop.classList.remove('js-carousel');
        loop.classList.add('rec-mobile-grid-active');

        var columns = loop.getAttribute(
          'data-mobile-grid-columns'
        ) || '2';

        loop.style.setProperty(
          '--mobile-grid-columns',
          columns === '1' ? '1' : '2'
        );

      } else {
        var wasGrid = loop.classList.contains(
          'rec-mobile-grid-active'
        );

        loop.classList.remove('rec-mobile-grid-active');
        loop.style.removeProperty('--mobile-grid-columns');

        if (wasGrid) {
          loop.classList.add('js-carousel');

          var parent = loop.closest(
            '.product-recommendations__wrapper'
          );

          if (parent) {
            carouselInit(parent);
          }
        }
      }
    });
  }

  function scheduleProductLayoutUpdate() {
    window.clearTimeout(resizeTimer);

    resizeTimer = window.setTimeout(
      updateProductRecommendationLayouts,
      200
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      updateProductRecommendationLayouts
    );
  } else {
    updateProductRecommendationLayouts();
  }

  window.addEventListener(
    'load',
    updateProductRecommendationLayouts
  );

  window.addEventListener(
    'resize',
    scheduleProductLayoutUpdate
  );

  document.addEventListener(
    'shopify:section:load',
    updateProductRecommendationLayouts
  );

  document.addEventListener(
    'shopify:section:select',
    updateProductRecommendationLayouts
  );
})();
